import React from "react";
import { NavLink } from "react-router-dom";

const TABS = [
    { to: "/legal/security", label: "Security" },
    { to: "/legal/privacy", label: "Privacy" },
    { to: "/legal/terms", label: "Terms" },
];

/**
 * Persistent mini-nav shown at the top of every legal page.
 * Underlines the active tab using react-router's NavLink `isActive`.
 */
export default function LegalTabs() {
    return (
        <nav
            aria-label="Legal navigation"
            data-testid="legal-mini-nav"
            style={{
                display: "flex",
                gap: 4,
                marginBottom: 28,
                borderBottom: "1px solid rgba(19,25,46,0.12)",
                paddingBottom: 0,
            }}
        >
            {TABS.map((t) => (
                <NavLink
                    key={t.to}
                    to={t.to}
                    data-testid={`legal-tab-${t.label.toLowerCase()}`}
                    end
                    style={({ isActive }) => ({
                        padding: "10px 16px",
                        fontSize: 13,
                        fontWeight: isActive ? 600 : 500,
                        color: isActive ? "var(--vy-navy)" : "rgba(19,25,46,0.55)",
                        textDecoration: "none",
                        borderBottom: isActive ? "2px solid var(--vy-gold)" : "2px solid transparent",
                        marginBottom: -1,
                        fontFamily: "IBM Plex Mono, monospace",
                        letterSpacing: "0.02em",
                        transition: "color 160ms ease, border-color 160ms ease",
                    })}
                >
                    {t.label}
                </NavLink>
            ))}
        </nav>
    );
}
